import styled from 'styled-components';

export const Container = styled.div`
	${(props) =>
		props.isImage ? 'background-image: url(' + props.bgImage + ');' : 'background-color: ' + props.bgImage + ';'}
	background-repeat: no-repeat;
	background-position: 50%;
	background-attachment: fixed;
	position: relative;
	padding-top: 3.15rem;
	min-height: calc(100vh - 3.15rem);
	background-size: cover;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: ${(props) =>
			props.isImage
				? 'linear-gradient(180deg, rgba(26, 35, 64, 0.24), rgba(26, 35, 64, 0.16) 28%, rgba(26, 35, 64, 0.08))'
				: 'transparent'};
		pointer-events: none;
		z-index: 0;
	}

	> * {
		position: relative;
		z-index: 1;
	}
`;

export const ListContainer = styled.div`
	box-sizing: border-box;
	height: calc(100vh - 3.15rem - 56px);
	display: flex;
	flex-direction: row;
	padding: 0.4rem 1rem 0.2rem;
	overflow-x: auto;
	overflow-y: hidden;
	white-space: nowrap;
	/* width */
	::-webkit-scrollbar {
		height: 0.75rem;
		width: 1rem;
		margin-bottom: 20px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: rgba(26, 35, 64, 0.24);
        margin:10rem;
        padding-bottom:1rem;
		border-radius: 5px;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		background-clip: padding-box;
		background: rgba(219, 234, 254, 0.72);

		border-radius: 5px;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: rgba(219, 234, 254, 0.9);
	}
`;
